import { Flex } from '@mantine/core';
import styles from './TypingIndicator.module.css';

export const TEST_ID = 'typing-indicator';

/**
 * Animated typing indicator (three dots) shown while waiting for AI response
 */
export const TypingIndicator = () => (
  <Flex data-testid={TEST_ID}>
    <div className={styles.dot} />
    <div className={styles.dot} />
    <div className={styles.dot} />
  </Flex>
);
